// Builds the `types` payload of the Excel transaction import: for every
// transaction type found in the Excel file, the Investime transaction type the
// user mapped to it, or "" when the Excel type is left unmapped.
//
// An unmapped Investime type has the value "" (initial state) or " " (the "-"
// option of ImportColumnSelectGeneral). Both are loosely equal to 0, so they
// must be skipped explicitly; otherwise the first Excel type (index 0) would
// map to the first unmapped Investime type.

export const isMappedValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== ""

// excelTypeOptions: [{key: <Excel type>, value: <index>}]
// investimeTypeMappings: [{key2: <Investime type>, value: "" | " " | "<index>"}]
export function buildTypeMappings(excelTypeOptions, investimeTypeMappings) {
  const mappings = investimeTypeMappings || []
  return (excelTypeOptions || []).map((option) => {
    const match = mappings.find(
      (m) => isMappedValue(m?.value) && Number(m.value) === Number(option.value)
    )
    return { key: option.key, value: match?.key2 || "" }
  })
}
